var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('nav',[_c('ul',[_c('li',[_c('router-link',{attrs:{"to":"/design1"}},[_vm._v("Design 1")])],1),_c('li',[_c('router-link',{attrs:{"to":"/design3"}},[_vm._v("Design 3")])],1)])]),_c('router-view')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }